export const hashquery = (key, value) => {
    var _a;
    const keys = Array.isArray(key) ? key : [key];
    const values = Array.isArray(value) ? value : [value];
    const q = (_a = window.location.hash.split('?')[1]) !== null && _a !== void 0 ? _a : '';
    const p = new URLSearchParams(q);
    keys.forEach((k, i) => {
        var _a;
        if (!value) {
            p.delete(k);
        }
        else {
            p.set(k, (_a = values[i]) !== null && _a !== void 0 ? _a : '');
        }
    });
    return p.toString();
};
